import moment from "moment-timezone";
import { getFormatedDate } from "./common";

const getDates = (startDate, stopDate) => {
  var start = new Date(startDate);
  var end = new Date(stopDate);
  let holidays_ = [];
  // Logic for getting rest of the dates between two dates("FromDate" to "EndDate")
  while (start <= end) {
    holidays_.push(getFormatedDate(moment(start), "YYYY-MM-DD"));
    var newDate = start.setDate(start.getDate() + 1);
    start = new Date(newDate);
  }
  return holidays_;
};

export const getHolidayDates = (ocassions) => {
  let holidayDates = [];
  if (ocassions.length) {
    ocassions.forEach((o) => {
      if (o.isHoliday) {
        const datesArr = getDates(o.dateRange.from, o.dateRange.to);
        holidayDates = holidayDates.concat(datesArr);
      }
    });
  }

  return holidayDates;
};

export const mergeDateAndTime = (date, time) => {
  if (!date || !time) return null;

  let ksaDateTime = moment.tz(date, "Asia/Riyadh");
  const parsedTime = moment(time, "h:mma");

  ksaDateTime = ksaDateTime
    .hour(parsedTime.hour())
    .minute(parsedTime.minute())
    .second(0)
    .millisecond(0);

  return ksaDateTime.format();
};

export const compareDateTime = ({ dateInput, comparison, hrsToAdd = 0, hrsToSubtract = 0 }) => {
  if (!dateInput || !comparison) return null;

  // Parse input while keeping its offset
  let targetDate = moment.parseZone(dateInput);

  // Adjust if needed
  if (hrsToAdd) targetDate = targetDate.add(hrsToAdd, "hours");
  else if (hrsToSubtract) targetDate = targetDate.subtract(hrsToSubtract, "hours");

  // Convert to Riyadh time
  targetDate = targetDate.tz("Asia/Riyadh");
  if (!targetDate.isValid()) return null;

  const nowKSA = moment().tz("Asia/Riyadh");

  switch (comparison) {
    case "isGreaterOrEqual":
      return targetDate.isSameOrAfter(nowKSA);
    case "isGreater":
      return targetDate.isAfter(nowKSA);
    case "isLessOrEqual":
      return targetDate.isSameOrBefore(nowKSA);
    case "isLess":
      return targetDate.isBefore(nowKSA);
    default:
      return null;
  }
};
